import { AssetRequest } from "types/AssetRequest";
import { vilniusTodayYmd, vilniusYmd } from "utils/vilnius-date";
import { errorCode } from "features/positions/positions-errors";

type TFunction = (key: string, options?: Record<string, unknown>) => string;

/** The server refuses a request comment longer than this; notes and reasons get the same box size. */
export const MAX_TEXT_LENGTH = 2000;

/** A calendar day as `YYYY-MM-DD` (Vilnius day, like every other date the backend stores). */
export function formatRequestDay(epochMs: number | null | undefined): string {
  return epochMs ? vilniusYmd(new Date(epochMs)) : "—";
}

/** A pending request whose needed-by day has already passed. `today` is injectable for tests. */
export function isOverdue(request: AssetRequest, today: string = vilniusTodayYmd()): boolean {
  if (request.status !== "pending" || !request.neededBy) return false;
  return vilniusYmd(new Date(request.neededBy)) < today;
}

const ERROR_KEYS: Record<string, string> = {
  EMPLOYEE_REQUIRED: "asset_requests_error_employee_required",
  EMPLOYEE_NOT_ACTIVE: "asset_requests_error_employee_not_active",
  COMMENT_REQUIRED: "asset_requests_error_comment_required",
  COMMENT_TOO_LONG: "asset_requests_error_comment_too_long",
  REASON_REQUIRED: "asset_requests_error_reason_required",
  REQUEST_NOT_PENDING: "asset_requests_error_not_pending",
  NOT_FOUND: "asset_requests_error_not_found",
};

/** Translated copy for a refused request; an unknown code falls back to the generic error. */
export function describeAssetRequestError(error: unknown, t: TFunction): string {
  const code = errorCode(error);
  return t(code && ERROR_KEYS[code] ? ERROR_KEYS[code] : "asset_requests_error_generic");
}
